<script>
import BaseSectionTitleSecondary from '../../../../components/Base/BaseSectionTitleSecondary.vue';
import dialog2Mixin from "../mixins/dialog2";

export default {
  mixins: [dialog2Mixin],
  data() {
    return {
      title: '',
      slogan: '',
      stores: [],
      image: '',
      description: '',
      notice: ''
    }
  },
}
</script>
<template>
  <el-dialog
    width="788px"
    :class="[$style.dialogPrepaidJtails, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]"
    :visible.sync="dialog2MixinVisible"
    append-to-body
    custom-class="isStyleBase"
    @closed="$Dialog2MixinOnDestroy"
  >
    <div class="d-flex align-items-center justify-content-center flex-wrap mb-2">
      <BaseStoreTagList
        :store-list="stores"
      />
    </div>
    <div class="dialogPrepaidJtails__title mb-4">{{ title }}</div>
    <div
      v-if="image && !!image"
      class="dialogPrepaidJtails__img mb-5"
      :style="{ backgroundImage: `url('${ image }')` }"
    >
    </div>
    <div
      v-if="description"
      class="mb-4"
    >
      <h3 v-if="!$globalDialog" class="dialogPrepaidJtails__subtitle">方案說明</h3>
      <BaseSectionTitleSecondary
        v-else
        title="方案說明"
      />
      <div
        class="lh-lg text-pre-wrap"
        v-text="description"
      ></div>
    </div>
    <div
      v-if="notice"
      class="mb-4"
    >
      <h3 v-if="!$globalDialog" class="dialogPrepaidJtails__subtitle">注意事項</h3>
      <BaseSectionTitleSecondary
        v-else
        title="注意事項"
      />
      <div
        class="lh-lg text-pre-wrap"
        v-text="notice"
      ></div>
    </div>
  </el-dialog>
</template>
<style lang="scss" module>
.dialogPrepaidJtails {
  :global {
    .dialogPrepaidJtails {
      &__title {
        @extend %FontSerifWeightJtails;

        font-size: 1.313rem;
        text-align: center;
      }
      &__img {
        padding-top: 25%;
        background-color: $color-bg-default;
        background-position: center;
        background-size: cover;
      }
      &__subtitle {
        @extend %FontSerifWeightJtails;

        margin-bottom: 0.5rem;
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .dialogPrepaidJtails {
        &__title {
          font-family: unset;
          font-size: 1.125rem;
          font-weight: 500;
          color: $color-secondary;
        }
      }
    }
  }
}
</style>
